import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=6d5612c0"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports